// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".top-message{border-top:1px solid red}.hekate-error-message{border-bottom:1px solid red;border-left:1px solid red;border-right:1px solid red;color:red;border-radius:0;background:#ffefef;display:block;padding-left:6px;margin-top:0;margin-bottom:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
